import { getRouteApi } from '@tanstack/react-router';

import { useProjectMedia } from '@/api/media';
import Spinner from '@/components/ui/spinner';
import { canWrite } from '@/features/permissions/resource-permissions';

import { FloorPlansCard } from './media-cards/floorplans-card';
import { ImagesCard } from './media-cards/images-card';

// TODO: Re-enable once project videos card is ready
// import { VideosCard } from './media-cards/videos-card';

const route = getRouteApi('/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout');

export const MediaDatabase = () => {
  const { projectId } = route.useParams();
  const { data, isPending } = useProjectMedia({ id: projectId });
  const project = route.useLoaderData();
  const canWriteMedia = canWrite(project.metadata?.permissions, 'media');

  const layouts = Object.values(data.layouts);
  const images = Object.values(data.images);

  if (isPending) {
    return <Spinner />;
  }

  return (
    <div className="new-ui grid grid-cols-[repeat(auto-fill,minmax(min(100%,150px),1fr))] gap-3">
      <ImagesCard data={images} projectId={projectId} canWriteMedia={canWriteMedia} />
      <FloorPlansCard data={layouts} projectId={projectId} canWriteMedia={canWriteMedia} />
      {/* <VideosCard projectId={projectId} /> */}
    </div>
  );
};
